export default function MonthDots({ done = 0, total = 11 }) {
  const arr = Array.from({ length: total + 1 });
  return (
    <div className="flex items-center gap-1.5 flex-wrap">
      {arr.map((_, i) => {
        const isDone = i < done;
        const isBonus = i === total;
        const isCurrent = i === done && !isBonus;
        return (
          <div
            key={i}
            className={`
              h-6 min-w-[24px] px-2 rounded-full text-[10px] font-bold flex items-center justify-center
              transition-transform
              ${isBonus
                ? "bg-brand-accent text-brand-page shadow-gold"
                : isDone
                  ? "bg-brand-primary text-brand-page"
                  : isCurrent
                    ? "bg-brand-line text-brand-accent border border-brand-primary"
                    : "bg-brand-sand2 text-brand-slate2 border border-brand-line-faint"}
            `}
          >
            {isBonus ? "★" : i + 1}
          </div>
        );
      })}
    </div>
  );
}
